/*
 * @Author: caiqin.xie
 * @since: 2023-08-14 19:23:26
 * @lastTime: 2023-11-24 10:02:58
 * @LastEditors: caiqin.xie
 * @message: 维修价格-人工费
 */
import React from "react";
import styles from "../../index.module.scss";

interface IList{
  [key:string]: any
  paramBOs: Record<string, string>[];
}
interface IProps {
  ctry: string;
  words: Record<string, string>;
  serviecFeeList: IList[]; // 维修服务费
}

const LaborServiceFee = (props:IProps) => {
  const {ctry, words, serviecFeeList} = props
  return (
    <>
    {serviecFeeList && serviecFeeList.length > 0 && (
      <>
        <h2 className={styles['labor-title']}>
          {words?.support_maintenance_price_labor_fee}
          {/* Labor service fee */}
        </h2>
        <ul className={`${styles["price-table"]} ${styles["service-table"]}`}>
          <li className={`${styles["table-item"]} ${styles["table-item-title"]}`}>
            <span className={styles["table-item-label"]}>
              {words?.support_maintenance_price_service_content}
              {/* Service content */}
            </span>
            <span className={styles["table-item-label"]}>
              {words?.support_maintenance_price_items}
              {/* Maintenance Items */}
            </span>
            <span className={`${styles["table-item-label"]} ${styles["label-cost"]}`}>
              {words?.support_maintenance_price_cost}
              {/* Cost */}
            </span>
          </li>
          {serviecFeeList && serviecFeeList.map((item, index) => (
            <li className={styles["table-item"]} key={index}>
              <div className={`${styles["table-item-label"]} ${styles["algin-center"]}`}>
                <span className={styles["full-width"]}>{item.name}</span>
              </div>
              <div className={styles["table-item-content"]}>
                {item.paramBOs && item.paramBOs.map((listItem, listIndex) => (
                  <div className={styles["full-width"]} key={listIndex}>
                    <span className={styles["table-item-label"]}>{listItem.name}</span>
                    <span className={styles["table-item-label"]}>{listItem.value}</span>
                  </div>
                ))}
              </div>
            </li>
          ))}
        </ul>
      </>
    )}
    </>
  )
}
export default LaborServiceFee